import './index.scss';
var retainedScrollCount = 0;
var clickCaptureElement = document.createElement('div');
clickCaptureElement.classList.add('scrolling-retainer__click-capture');
clickCaptureElement.addEventListener('click', bodyClickListener); /// Resets the count of retained scrolling.
/// This does not release scrolling if it is held.

export function resetScrollingRetention() {
  retainedScrollCount = 0;
} /// Prevents elements in the document from interaction. This uses a counter, which increases which every call.
///
/// Elements with the class 'scrolling-retainer__click-capture' will still be interactive.

export function retainDocumentScrolling() {
  if (retainedScrollCount === 0) {
    document.body.classList.add('scrolling-retainer--active');
    document.body.insertBefore(clickCaptureElement, document.body.firstChild);
  }

  retainedScrollCount += 1;
} /// Release the document from inaction. This uses a counter, and will only actually release the document when it reaches
/// 0.

export function releaseDocumentScrolling() {
  if (retainedScrollCount <= 1) {
    retainedScrollCount = 0;
    document.body.classList.remove('scrolling-retainer--active');
    clickCaptureElement.remove();
  } else {
    retainedScrollCount -= 1;
  }
} /// Listens for clicks on the body while the document is retained. Releases the document when fired.
///
/// Triggers the following events:
/// - "scrolling-retainer:releasing" fired just before releasing the document. Can be prevented.
/// - "scrolling-retainer:released" fired after releasing the document.

function bodyClickListener(event) {
  var retval = bodyDisableListener(event);

  if (!retval) {
    var proceed = document.dispatchEvent(new Event('scrolling-retainer:releasing'));

    if (proceed) {
      retainedScrollCount = 0;
      releaseDocumentScrolling();
      document.dispatchEvent(new Event('scrolling-retainer:released'));
      document.querySelectorAll('.retained-scrolling').forEach(function (retainer) {
        return retainer.releaseScrolling();
      });
    }
  }

  return retval;
} /// Checks if an event triggered by the clickCaptureElement was bubbled up from an element which is receiving events.


function bodyDisableListener(event) {
  var target = event.target;

  while (target) {
    if (target.retainedScrolling) {
      return true;
    }

    target = target.parentElement;
  }

  event.preventDefault();
  return false;
} /// Retains scrolling from the current element. The element will still receive events.


HTMLElement.prototype.retainScrolling = function () {
  if (!this.retainedScrolling) {
    this.retainedScrolling = true;
    this.classList.add('retained-scrolling');
    retainDocumentScrolling();
    var item = this;

    while (item && item !== document.body) {
      item.classList.add('retained-scrolling-container');
      item = item.parentElement;
    }
  }
}; /// Releases scrolling from the current element.


HTMLElement.prototype.releaseScrolling = function () {
  if (this.retainedScrolling) {
    this.retainedScrolling = false;
    this.classList.remove('retained-scrolling');
    releaseDocumentScrolling();
    var item = this;

    while (item && item !== document.body) {
      item.classList.remove('retained-scrolling-container');
      item = item.parentElement;
    }
  }
};